<template>
	<div id="dataswipertitle">
		<h2 :class="fulltitle ? 'title dataswipertitle' : 'pagetitle title'" @click="drawer = !drawer">
			<!-- 
			<span v-if="userdata.countyText !=''">{{userdata.countyText}}</span> -->
			<!-- <span>{{bigtitle}}</span> -->
			{{ title }}<i class="el-icon-arrow-down dataswipertitle_icon"></i>

			<div class="year-filter" v-if="isShowYear">
				<el-date-picker v-model="startYear" format="yyyy" value-format="yyyy" type="year" placeholder="选择年">
				</el-date-picker>
				-
				<el-date-picker v-model="endYear" format="yyyy" value-format="yyyy" type="year" placeholder="选择年">
				</el-date-picker>
				<el-button class="ml-2" type="primary" size="" @click="changeYear">确定</el-button>
			</div>
		</h2>

		<div class="Drawerbox1" @click="drawer = false" v-show="drawer">
			<div class="Drawer1">
				<!-- <dl>
					<dt class="dtitle">综合发展：</dt>
					<dd>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'HGSJ'}" @click="routerself('/hongguanshuju-saas')">{{titlecity1}}宏观数据监测</span>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'DDJJFZ'}"  @click="routerself('/dangdijingjifazhan-saas')" v-show="userdata.countyText !='' && userdata.countyText!='东营经济技术开发区'">{{userdata.countyText}}当地经济发展</span>
						<span :class="{'Drawer_li':true,'D-current':navcode == 'JZL'}" @click="routerself('/jingzhengli-saas')"   v-show="!isprovince">{{titlecity}}竞争力数字大屏</span>
						</dd> 
					</dl>   -->

				<dl>
					<dt class="dtitle">湖南概况：</dt>
					<dd>
						<span :class="{ 'Drawer_li': true, 'D-current': navcode == 'CYTX' }"
							@click="routerself('/gov-industrialSystem')">4 × 4 产业体系</span>
						<span :class="{ 'Drawer_li': true, 'D-current': navcode == 'SZGK' }"
							@click="routerself('/gov-prefecturesOverview')">14个市州概况</span>
						<span :class="{ 'Drawer_li': true, 'D-current': navcode == 'QYGK' }"
							@click="routerself('/gov-keyEnterprises')">重点企业概况</span>
					</dd>
				</dl>
				<dl>
					<dt class="dtitle">湖南招商：</dt>
					<dd>

						<span :class="{ 'Drawer_li': true, 'D-current': navcode == 'INVEST' }"
							@click="routerself('/gov-invest')">全国上市公司投资湖南</span>
						<span :class="{ 'Drawer_li': true, 'D-current': navcode == 'LAND' }"
							@click="routerself('/gov-land')">全国企业在湖南拿地投资</span>
					</dd>
				</dl>
				<dl>
					<dt class="dtitle">湘粤互动：</dt>
					<dd>

						<span :class="{ 'Drawer_li': true, 'D-current': navcode == 'GDINVEST' }"
							@click="routerself('/gov-guandongInvest')">广东上市公司投资湖南</span>
						<span :class="{ 'Drawer_li': true, 'D-current': navcode == 'GDLAND' }"
							@click="routerself('/gov-guandongLand')">广东企业在湖南拿地投资</span>
					</dd>
				</dl>
				<video-teaching :type="4" style="margin-left:140px;"></video-teaching>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'daswiperNav',
	data() {
		return {
			name: "招商大屏菜单栏", userdata: {}, drawer: false, isprovince: false, titlecity: '', titlecity1: "", bigtitle: "",

			list1: ['宏观数据监测', '当地经济发展', '竞争力数字大屏', '招商大地图', '招商环境', '全国上市公司投资湖南', '招商图谱', '产业发展', '产业用地', '企业数据'],
			titlelist: [
				{
					code: "ZHFZ", title: "综合发展", chidren: [
						{ code: "HGSJJC", title: "宏观数据监测" },
						{ code: "DDJJFZ", title: "当地经济发展" },
						{ code: "JZLSZDP", title: "竞争力数字大屏" },
					]
				},
				{
					code: "ZSHJ", title: "招商环境", chidren: [
						{ code: "ZSDDT", title: "招商大地图" },
						{ code: "ZSHJ", title: "招商环境" },
						{ code: "ZSXM", title: "全国上市公司投资湖南" },
						{ code: "ZSTP", title: "招商图谱" },
					]
				},
				{
					code: "CYFZ", title: "产业发展", chidren: [
						{ code: "CYFZ", title: "产业发展" },
						{ code: "CYYD", title: "产业用地" },
						{ code: "QYSJ", title: "企业数据" },
					]
				},

			],
			startYear: '2021',
			endYear: '2025',
		}
	},
	props: {
		indexnum: Number,
		title: String,
		fulltitle: Boolean,
		navcode: { type: String, require: true },
		isShowYear: {type:Boolean,default:true},
		// drawer1:Boolean,
	},
	// watch:{
	// 	drawer1:{
	// 		handler(newValue,oldValue){ 
	// 			this.type=newValue; 
	// 			// console.log('123123',$('.nav_li').eq(this.curindex).siblings('.nav_li'))

	// 		}  
	// 	}, 
	// },
	mounted() {
		this.userdata = this.getuseriformation();
		// for(var i=0;i<this.list1.length;i++){
		// 	if(this.title.indexOf(this.list1[i])>-1 ){
		// 			document.getElementsByClassName('Drawer_li')[i].className="Drawer_li D-current";
		// 	}
		// }
		// if(this.indexnum){
		// 	var indexnums=this.indexnum-1;
		// 	console.log(indexnums)
		// 	document.getElementsByClassName('Drawer_li')[indexnums].className="Drawer_li D-current";
		// }
		this.isprovince = this.userdata.userAbbr.length > 0 && this.userdata.provinceText.indexOf(this.userdata.userAbbr) > -1;
		this.titlecity = this.userdata.currentCity.text;
		if (this.userdata.currentCity.type == "county") {
			this.titlecity1 = this.userdata.cityText;
		} else {
			this.titlecity1 = this.titlecity;
		}
		this.bigtitle = (this.title.indexOf('宏观数据') > -1 && this.userdata.currentCity.type == "county") ? this.userdata.cityText : this.titlecity;


	},
	methods: {
		changeYear(val) {
			// console.log(this.startYear,this.endYear);
			//判断起始年份不能大于结束年份
			if (this.startYear > this.endYear) {
				this.$message.error('起始年份不能大于结束年份');
				return;
			}
			 this.$emit('yearChange', { startYear: this.startYear, endYear: this.endYear });
		},
	}

}
</script>

<style lang="scss" scoped>
.Drawerbox1 {
	left: 0;
}

#dataswipertitle>.title {
	font-size: 36px;
	text-align: center;
	letter-spacing: 2px;
	margin-bottom: 10px;
	cursor: pointer;
}

/* .dataswipertitle1{
		color: #59ccc2;   line-height: 108px;
	} */
.dataswipertitle {
	postion: relative;

	.year-filter {
		position: absolute;
		right: -440px;
		top: 0;

	}

}

::v-deep .el-date-editor.el-input {
	width: 150px;

	.el-input__inner {
		background-color: rgba(0, 0, 0, 0);
		color: #fff;
	}
}
</style>